<div class="overview-panel bg-white">
    <div class="menu-content py-3 mx-2">
        <div class="p-2">
            <fa-icon class="w-10" [icon]="faEarthAsia"></fa-icon>
            <span class="ms-3">Select Sources</span>
        </div>
        <div class="p-2">
            <fa-icon class="w-10" [icon]="faSearch"></fa-icon>
            <span class="ms-3">Previous Search</span>
        </div>
        <div class="previous-list ps-2 pt-2 pe-2">
            <div class="ms-4">
                <div class="py-1">
                    <span class="ms-2">Reviews</span>
                    <fa-icon class="float-end" [icon]="faEllipsisV"></fa-icon>
                </div>
                <div class="py-1">
                    <span class="ms-2">Reviews</span>
                    <fa-icon class="float-end" [icon]="faEllipsisV"></fa-icon>
                </div>
            </div>
        </div>
    </div>
</div>
